module.exports = __webpack_public_path__ + "d56108f95216303100418e7d2eeb7f11.svg";